import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import PropTypes from "prop-types";
import { withSearch } from "..";
import { Paging } from "@elastic/react-search-ui-views";
export function PagingContainer(_ref) {
  var className = _ref.className,
      current = _ref.current,
      resultsPerPage = _ref.resultsPerPage,
      setCurrent = _ref.setCurrent,
      totalPages = _ref.totalPages,
      view = _ref.view,
      rest = _objectWithoutProperties(_ref, ["className", "current", "resultsPerPage", "setCurrent", "totalPages", "view"]);

  if (totalPages === 0) return null;
  var View = view || Paging;
  return View(_objectSpread({
    className: className,
    current: current,
    resultsPerPage: resultsPerPage,
    totalPages: totalPages,
    onChange: setCurrent
  }, rest));
}
PagingContainer.propTypes = {
  // Props
  className: PropTypes.string,
  view: PropTypes.func,
  // State
  current: PropTypes.number.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  // Action
  setCurrent: PropTypes.func.isRequired
};
export default withSearch(function (_ref2) {
  var current = _ref2.current,
      resultsPerPage = _ref2.resultsPerPage,
      totalPages = _ref2.totalPages,
      setCurrent = _ref2.setCurrent;
  return {
    current: current,
    resultsPerPage: resultsPerPage,
    totalPages: totalPages,
    setCurrent: setCurrent
  };
})(PagingContainer);